import script from "./userPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./userPicker.vue?vue&type=script&setup=true&lang=ts"

import "./userPicker.vue?vue&type=style&index=0&id=9445c35e&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9445c35e"]])

export default __exports__